
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recurring-waste-services",
      function () {
        return require("private-next-pages/recurring-waste-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recurring-waste-services"])
      });
    }
  